import { getPluralString } from '@awaze/design-system.utils.react';
export const formatNightsString = (nights, nightLabel, nightsLabel) => `${nights} ${getPluralString(nights, nightLabel, nightsLabel)}`;
export const formatRangeString = (range, daysLabel) => `+/- ${range} ${daysLabel}`;
export const formatGuestsString = (guests, guestLabel, guestsLabel) => `${guests} ${getPluralString(guests, guestLabel, guestsLabel)}`;
//# sourceMappingURL=search-summary.utils.js.map